import React, { useEffect, useState } from 'react'

export default function useTheme() {
    const [theme, setTheme] = useState({
        secondaryColor: '#1C1816',
        backgroundColor: '#000',
        fontColor: "#fff",
        headerColor: "#000",
        borderColor: "#000",
        lightTheme: "#1c1816",
        borderTheme: "#1c1816",
        footerColor: "#fff",
        footerTheme: "#1c1816",
        themeBtn : "#000",
        lightthemeBtn : "#e4002b",
      });
    
      useEffect(() => {
        const savedTheme = localStorage.getItem("color-theme");
    
        if (savedTheme) {
          setTheme(JSON.parse(savedTheme));
        }
      }, []);
    
      function toggleTheme() {
        const newTheme = {
            backgroundColor: '#f1f3f6',
            secondaryColor: '#fff',
            fontColor: "#000",
            headerColor: "#fff",
            borderColor: "#e4002b",
            lightTheme: "rgba(223,239,255,.3)",
            borderTheme: "#dfefff",
            footerTheme: "#393f52",
            footerColor: "#fff",
            themeBtn : "#e4002b",
            lightthemeBtn : "#fff",
        };
    
        setTheme(newTheme);
        localStorage.setItem("color-theme", JSON.stringify(newTheme));
      }
    
      useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty("--black", theme.backgroundColor);
        root.style.setProperty("--second-color", theme.secondaryColor);
        root.style.setProperty("--white", theme.fontColor);
        root.style.setProperty("--header-color", theme.headerColor);
        root.style.setProperty("--border-color", theme.borderColor);
        root.style.setProperty("--light-theme", theme.lightTheme);
        root.style.setProperty("--border-theme", theme.borderTheme);
        root.style.setProperty("--footer-theme", theme.footerTheme);
        root.style.setProperty("--footer-color", theme.footerColor);
        root.style.setProperty("--dark-mode", theme.themeBtn);
        root.style.setProperty("--light-mode", theme.lightthemeBtn);
      }, [theme]);


    //   ===Black Theme===

    const [blacktheme, setBlackTheme] = useState({
        secondaryColor: '#1C1816',
        backgroundColor: '#000',
        fontColor: "#fff",
        headerColor: "#000",
        borderColor: "#000",
        lightTheme: "#1c1816",
        borderTheme: "#1c1816",
        footerColor: "#fff",
        footerTheme: "#1c1816",
        themeBtn : "#000",
        lightthemeBtn : "#e4002b",
      });
    
      useEffect(() => {
        const savedTheme = localStorage.getItem("color-theme");
    
        if (savedTheme) {
            setBlackTheme(JSON.parse(savedTheme));
        }
      }, []);
    
      function toggleBlackTheme() {
        const newTheme = {
            backgroundColor: '#f1f3f6',
            secondaryColor: '#fff',
            fontColor: "#000",
            headerColor: "#fff",
            borderColor: "#e4002b",
            lightTheme: "rgba(223,239,255,.3)",
            borderTheme: "#dfefff",
            footerTheme: "#393f52",
            footerColor: "#fff",
            themeBtn : "#e4002b",
            lightthemeBtn : "#fff",
        };
    
        setTheme(newTheme);
        localStorage.setItem("color-theme", JSON.stringify(newTheme));
      }
    
      useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty("--black", theme.backgroundColor);
        root.style.setProperty("--second-color", theme.secondaryColor);
        root.style.setProperty("--white", theme.fontColor);
        root.style.setProperty("--header-color", theme.headerColor);
        root.style.setProperty("--border-color", theme.borderColor);
        root.style.setProperty("--light-theme", theme.lightTheme);
        root.style.setProperty("--border-theme", theme.borderTheme);
        root.style.setProperty("--footer-theme", theme.footerTheme);
        root.style.setProperty("--footer-color", theme.footerColor);
        root.style.setProperty("--dark-mode", theme.themeBtn);
        root.style.setProperty("--light-mode", theme.lightthemeBtn);
      }, [theme]);
    
      return { theme, toggleTheme }
 
}
